var prodcat = prodcat || {};

prodcat.data = prodcat.data || {};
var YMK = YMK || {};
var site = site || {};

(function ($) {
  Drupal.behaviors.productFoundationVtoV1 = {
    isMobile: function() {
      return window.screen.width < 768;
    },
    attach: function (context) {
      var $productFoundationVto = $('.js-product-foundation-vto-v1', context);
      var self = this;

      if (!$productFoundationVto.length) {
        return;
      }
      var autoTriggerYoucam = window.location.href.indexOf('vto_open') !== -1;
      var hasVtoDiscloseParam = window.location.href.indexOf('vto_disclose') !== -1;
      var hasVtoDisPriceParam = window.location.href.indexOf('vto_disprice') !== -1;
      var showCloseBtn = hasVtoDiscloseParam ? false : true;
      var $foundationVtoButton = $('.js-product-foundation-vto-btn', context);
      var $foundationVtoContainer = $('.js-product-foundation-vto-container', $productFoundationVto);
      var $foundationVtoQrOverlay = $('.js-product-full__foundation-qrcode', context);
      var $mobileShadePickContainer = $('.js-product-foundation-shade-container', $productFoundationVto);
      var $mobileShadePicker = $('.js-shade-picker-vto', $productFoundationVto);
      var $addToBagButton = $('.js-add-to-cart', $productFoundationVto);
      var $prevCar = $('.js-shades-vto-prev', $productFoundationVto);
      var $nextCar = $('.js-shades-vto-next', $productFoundationVto);
      var $foundationVtoOverlayContainer = $('.js-product-foundation-vto-overlay-container', $productFoundationVto);
      var $foundationVtoOverlayButton = $('.js-product-foundation-vto-overlay-button', $productFoundationVto);
      var $productPriceContainer = $('.js-shadeprice', $mobileShadePickContainer);
      var overlayHtmlContent = site.template.get({
        name: 'foundation_vto_overlay_v1'
      });

      $foundationVtoOverlayContainer.html(overlayHtmlContent);
      var $foundationVtoUndertoneContainer = $('.js-product-foundation-vto-undertone-container', $productFoundationVto);
      var undertoneHtmlContent = site.template.get({
        name: 'product_foundation_undertone_v1'
      });

      $foundationVtoUndertoneContainer.html(undertoneHtmlContent);
      // overlay elements
      var $foundationVtoUndertoneContent = $('.js-product-foundation-vto-undertone-container', $productFoundationVto);
      var $foundationVtoOverlayButton = $('.js-product-foundation-vto-overlay-button', $productFoundationVto);
      var $foundationVtoUndertoneBackground = $('.js-product-foundation-vto-undertone-background', $productFoundationVto);
      var $foundationVtoIframe = $('.js-product-foundation-vto-iframe', $productFoundationVto);
      var $swatches = $('.js-swatches', $mobileShadePicker);
      var $firstSwatch = $swatches.first();
      var $lastSwatch = $swatches.last();
      var $swatch = $('.js-swatch', $mobileShadePicker);
      var $swatchFilter = $('.js-vto-filter-text', $swatches);
      var drupalGlobalVar = Drupal.settings.global_variables || {};

      $swatches.each(function () {
        var $swatchElement = $(this);
        var $swatchVtoContent = $('.js-vto-text', $swatchElement);
        var swatchVtoText = $swatchVtoContent.html();
        var shadeValue = '';

        if (drupalGlobalVar.foundation_vto_uk || drupalGlobalVar.foundation_vto_th) {
          shadeValue = swatchVtoText.split(/[/\s/]/);
          var shadeFirst = shadeValue[0] ? shadeValue[0] : '';
          var shadeSecond = shadeValue[1] ? ' ' + shadeValue[1] : '';

          $swatchVtoContent.html(shadeFirst + shadeSecond);
        } else if (drupalGlobalVar.foundation_vto_jp || drupalGlobalVar.foundation_vto_cn || drupalGlobalVar.foundation_vto_tw) {
          shadeValue = swatchVtoText.split(/[/\s/]/);
          $swatchVtoContent.html(shadeValue[0] ? shadeValue[0] : '');
        } else {
          shadeValue = swatchVtoText.split(/[(\/)]/);
          $swatchVtoContent.html(shadeValue[1] || '');
        }
      });
      var $foundationOverlayClose = $('.js-product-foundation-vto-overlay-close', $productFoundationVto);
      var $foundationVtoUndertoneClose = $('.js-product-foundation-vto-undertone-close', $productFoundationVto);
      var $foundationVtoUndertonePopup = $('.js-undertone-cta-text', $productFoundationVto);
      var isMob = Unison.fetch.now().name === 'small';
      var youcamAPIKey = Drupal.settings.foundation_vto.api_key;
      var youcamAPIUrl = Drupal.settings.foundation_vto.api_url;
      var language = Drupal.settings.foundation_vto.language;
      var vtoLanguageCaFr = Drupal.settings.vto_language_fr;
      var pageLanguage = $('html').attr('lang');
      var splitWindowPositionheight = 5;
      var splitWindowPosition = Drupal.settings.foundation_vto.split_window_position || $mobileShadePickContainer.height() + splitWindowPositionheight;
      var $seeAllshade = $('.js-see-all-shade', $productFoundationVto);
      var $seeMyPerfect = $('.js-see-perfect', $productFoundationVto);
      var $bodyElement = $('body', context);
      var foundationResults = [];
      var shadeSelected = false;
      var $swatchContainer;
      var $shadeContainer;
      var youcamEvents = [
        'cameraFailed',
        'cameraOpened',
        'compare',
        'compareDisabled',
        'closed',
        'loaded',
        'loading',
        'kissDetected',
        'opened',
        'photoLoaded',
        'photoSaved',
        'reset',
        'videoLoaded',
        'shadeFinderStarted',
        'shadeFinderCancelled',
        'skinShadeFound',
        'zoom',
        'cameraClosed',
        'engineClosed',
        'modelLoaded',
        'skinAnalysisUpdated',
        'split4Way',
        'split4WayDisabled'
      ];

      site.skuSelect = function (skuData) {
        if (!skuData) {
          return;
        }
        var prodId = skuData.PRODUCT_ID;
        var prodSelector = "[data-product-id='" + prodId + "']";

        $(prodSelector).trigger('sku:select', skuData);
      };

      if (isMob) {
        var $vtoElement = $foundationVtoContainer.remove();

        $vtoElement.appendTo($bodyElement);
        // set height to screen height
        $foundationVtoContainer.height($(window).height());
      }
      (function (d, k) {
        var s = d.createElement('script');

        s.type = 'text/javascript';
        s.async = true;
        s.src = youcamAPIUrl + k;
        var x = d.getElementsByTagName('script')[0];

        x.parentNode.insertBefore(s, x);
      })(document, youcamAPIKey);

      window.ymkAsyncInit = function (skipEventListener) {
        var productId = $addToBagButton.data('product-id').replace('PROD', '');
        var vtoParams = {
          showCloseBtnOnLauncher: showCloseBtn,
          bottomPanelOffsetY: splitWindowPosition
        };

        if (Drupal.settings.foundation_vto.is_product_list_enabled) {
          vtoParams['productIdList'] = [productId];
        }

        if (pageLanguage === 'fr') {
          vtoParams['language'] = vtoLanguageCaFr;
        } else if (language) {
          vtoParams['language'] = language;
        }

        window.YMK.init(vtoParams);
        if (skipEventListener) {
          return;
        }
        youcamEvents.forEach(function (event) {
          window.YMK.addEventListener(event, function (result, progress) {
            if (event === 'compare' || event === 'compareDisabled') {
              $mobileShadePickContainer.addClass('active');
            } else {
              $mobileShadePickContainer.removeClass('active');
              $swatches.removeClass('vto-filter first-filter active js-best-match best-match vto-pipe-first vto-pipe-last js-foundation-vto-lighter foundation-vto-lighter js-foundation-vto-warmer foundation-vto-warmer js-foundation-vto-guid foundation-vto-guid js-foundation-vto-cooler foundation-vto-cooler js-foundation-vto-darker foundation-vto-darker last-filter');
              $swatchFilter.html('');
            }
            if (event === 'loaded') {
              hideVtoPrice();
              // add current sku
              if (isMob) {
                toggleMobileShadePick('on');
              }
            }
            if (event === 'opened' && autoTriggerYoucam) {
              $foundationVtoButton.addClass('hidden');
            }
            if (event === 'closed') {
              if (isMob) {
                toggleMobileShadePick('off');
              }
              closeYoucamModule();
            }
            if (event === 'skinShadeFound') {
              if (result.readableRecommendations) {
                foundationResults = result;
                skinShadeFilter();
                $mobileShadePickContainer.addClass('active');
                $seeMyPerfect.removeClass('active');
                if ($mobileShadePicker.find('.vto-filter').length) {
                  $seeAllshade.addClass('active');
                  $swatches.removeClass('active');
                  changeSKU($mobileShadePicker.find('.vto-filter.js-best-match .js-swatch'));
                } else {
                  $seeAllshade.removeClass('active');
                  $swatches.addClass('active');
                  changeSKU($mobileShadePicker.find('.js-swatch').first());
                }
              }
            }
            // MTA-2589 - Analytics tagging for YouCam events - Starts
            if (site && site.track) {
              var productName, eventName, skuID;
              var data = site.track.refreshData();

              if (data && data.product_name && data.product_name.length && data.product_sku && data.product_sku.length) {
                productName = data.product_name[0].replace(/(<([^>]+)>)/ig, '');
                skuID = data.product_sku[0];
              }
              // Setting up currently selected SKU ID
              var selectedSku = $swatch.filter('.selected').attr('data-sku-base-id');

              if (selectedSku && selectedSku !== '') {
                skuID = 'SKU' + selectedSku;
              }
              // Supressing multiple event tag fires during loading youcam event
              if (event === 'loading') {
                if (result === 10) {
                  eventName = 'loading';
                } else if (result === 100) {
                  eventName = 'loaded';
                }
              } else {
                eventName = event;
              }
              if (eventName && eventName !== '') {
                site.track.evtLink({
                  event_name: 'vto',
                  event_category: 'youcam',
                  event_action: eventName,
                  event_label: skuID + ' - ' + productName
                });
              }
            }
            // MTA-2589 - Analytics tagging for YouCam events - Ends
          });
        });
        if (autoTriggerYoucam && isMob) {
          openYoucamModule();
        }
      };

      function setShadeWidth(width) {
        var $perfectMatchClass = $('.vto-filter', $mobileShadePicker);

        $perfectMatchClass.css('width', width);
      }

      function skinShadeFilter() {
        if (foundationResults.readableRecommendations && foundationResults.readableRecommendations.length) {
          var currentShadeMatchFound = 0;
          var perfectMatch = foundationResults.readableRecommendations[0];

          if (perfectMatch) {
            $mobileShadePicker.removeClass('all-shades');
            $mobileShadePicker.addClass('perfect-shades');
            $swatches.removeClass('vto-filter first-filter js-best-match best-match vto-pipe-first vto-pipe-last js-foundation-vto-lighter foundation-vto-lighter js-foundation-vto-warmer foundation-vto-warmer js-foundation-vto-guid foundation-vto-guid js-foundation-vto-cooler foundation-vto-cooler js-foundation-vto-darker foundation-vto-darker last-filter');

            var $swatch = $('.js-swatches', $mobileShadePicker);
            var checkClone = $swatch.hasClass('cloned');

            if (checkClone) {
              $swatch.filter('.cloned').remove();
            }
            $.each(perfectMatch, function (skin) {
              var skinData = perfectMatch[skin];

              if ($.isNumeric(skinData)) {
                return;
              }

              var $shadeElement = $mobileShadePicker.find('[data-sku-product-code="' + skinData + '"]').closest('.js-swatches');

              if ($shadeElement.length) {
                currentShadeMatchFound = 1;
                var skinText = $productFoundationVto.attr('data-foundation-' + skin);
                var liClass = 'vto-filter js-foundation-vto-' + skin + ' foundation-vto-' + skin;
                var filterClass = skin === 'guid' ? 'js-best-match best-match vto-filter selected js-foundation-vto-guid foundation-vto-guid' : liClass;
                var isSameSku = $shadeElement.hasClass('vto-filter');

                if (isSameSku) {
                  var $swatchList = $shadeElement.parent($mobileShadePickContainer);

                  $shadeElement.clone(true).addClass('cloned').appendTo($swatchList);
                  $shadeElement = $('.cloned', $swatchList);
                  $swatchContainer = $shadeElement;
                }

                $shadeElement.addClass(filterClass).find('.js-vto-filter-text').html(skinText).attr('data-filter-text', skin);

                if (skin === 'guid') {
                  var $bestMatchSwatch = $shadeElement.find('.swatch__container').find('.js-swatch');

                  changeSKU($bestMatchSwatch);
                }
              }
            });
            var $vtoFoundationFilter = $mobileShadePicker.find('.vto-filter');
            $vtoFoundationFilter = $vtoFoundationFilter.sort((a, b) => {
              return $(a).css('order') < $(b).css('order') ? -1 : 1;
            });

            if (!$vtoFoundationFilter.length) {
              $mobileShadePicker.removeClass('perfect-shades');
            }
            $vtoFoundationFilter.first().addClass('first-filter vto-pipe-first');
            $vtoFoundationFilter.last().addClass('last-filter vto-pipe-last');
            $vtoFoundationFilter.length === 2 && $vtoFoundationFilter.addClass('vto-single-pipe');
            
            var perfectMatchShades = $('.vto-filter').length * $firstSwatch;

            if (perfectMatchShades) {
              setShadeWidth(100 / perfectMatchShades + '%');
            }
            $prevCar.addClass('hidden');
            $nextCar.addClass('hidden');
          }
          if (currentShadeMatchFound) {
            $seeMyPerfect.addClass('active');
          } else {
            $seeMyPerfect.removeClass('active');
          }
        }
      }

      function openYoucamModule() {
        var $chatLiveIcon = $('.LPMcontainer');

        $chatLiveIcon.addClass('hidden');
        var $chatLiveButton = $('.wo-chat-btn');

        $chatLiveButton.addClass('hidden');
        var $chatLiveButtonLabel = $('.lt-label-icon-wrap');

        $chatLiveButtonLabel.addClass('hidden');
        var $chatIcon = $('.lt-label-event');

        $chatIcon.addClass('hidden');
        $foundationVtoButton.addClass('hidden');
        $foundationVtoContainer.removeClass('hidden');
        $foundationVtoOverlayContainer.removeClass('hidden');
        if (hasVtoDiscloseParam) {
          $foundationOverlayClose.addClass('hidden');
        }
        $foundationVtoIframe.addClass('hidden');
        $foundationVtoUndertoneContainer.addClass('hidden');
        $foundationVtoUndertoneBackground.addClass('hidden');
        $foundationVtoUndertoneContent.addClass('hidden');
        autoTriggerYoucam = 0;

        // disable scrolling
        window.scrollTo(0, 0);
        $bodyElement.addClass('no-scroll');
      }

      function hideVtoPrice() {
        var isRetailer = $bodyElement.hasClass('is-retailer');

        // vto_disprice & addtobag=0 should work together. Hide the price and addtobag should remain consistent.
        if (hasVtoDisPriceParam && isRetailer && !$.cookie('vto_disprice')) {
          $.cookie('vto_disprice', '1', { path: '/' });
          $productPriceContainer.addClass('hidden');
        } else if ($.cookie('vto_disprice') && isRetailer) {
          $productPriceContainer.addClass('hidden');
        } else if ($.cookie('vto_disprice') && !isRetailer) {
          $.cookie('vto_disprice', null, { path: '/' });
        }
      }

      $foundationVtoOverlayButton.once().on('click', function (e) {
        e.preventDefault();
        var userAgent = navigator.userAgent;
        var iosBrowserErrorCopy = $productFoundationVto.data('ios-browser-error-copy');
        var $overlayContent = $('.js-foundation-vto-overlay-content', $foundationVtoOverlayContainer);
        var $disclaimerCheck = $('.js-vto-disclaimer-checkbox', $foundationVtoOverlayContainer);

        if (userAgent.match(/iPhone|iPad/i) && !userAgent.match(/Version\/[\d\.]+.*Safari/) && !(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)) {
          if (typeof iosBrowserErrorCopy !== 'undefined') {
            $.colorbox({
              html: iosBrowserErrorCopy,
              width: '300px',
              height: 'auto',
              className: 'vto-ios-browser-error',
              display: 'inline',
              onOpen: function () {
                $overlayContent.hide();
              },
              onClosed: function () {
                $overlayContent.show();
              }
            });
            $('#cboxOverlay').hide();
          }

          return;
        }
        if ($disclaimerCheck.length > 0 && !$disclaimerCheck.is(':checked')) {
          return;
        }

        $foundationVtoOverlayContainer.addClass('hidden');
        $foundationVtoIframe.removeClass('hidden');
        window.YMK.open(true, null, true);
      });

      function isScrolledIntoViewHorizontal($element, $container) {
        var elementLeft = $element.offset().left;
        var elementRight = elementLeft + $element.outerWidth(true);
        var isVisible = elementRight > 1 && Math.ceil(elementRight) < $container.outerWidth(true) + $firstSwatch.outerWidth(true);

        return isVisible;
      }
      $mobileShadePicker.scroll(_.debounce(function () {
        var firstInGrid = isScrolledIntoViewHorizontal($firstSwatch, $mobileShadePicker);
        var lastInGrid = isScrolledIntoViewHorizontal($lastSwatch, $mobileShadePicker);
        var fullCarouselLength = $swatches.length * $firstSwatch.outerWidth(true);

        if (fullCarouselLength <= $mobileShadePicker.outerWidth(true)) {
          $nextCar.addClass('hidden');
        } else {
          if (firstInGrid && !lastInGrid) {
            $prevCar.addClass('hidden');
            $nextCar.removeClass('hidden');
          } else if (!firstInGrid && !lastInGrid) {
            $nextCar.removeClass('hidden');
            $prevCar.removeClass('hidden');
          } else if (lastInGrid && !firstInGrid) {
            $nextCar.addClass('hidden');
            $prevCar.removeClass('hidden');
          }
        }
      }, 10));
      $prevCar.add($nextCar).once().on('click', function (event) {
        var isShadeNext = $(event.target).hasClass('js-shades-vto-next');
        var carouselWidth = $mobileShadePickContainer.outerWidth(false);
        var position = $swatches.position().left;
        var scrollPosition = isShadeNext ? carouselWidth - Math.floor(position) : -position - carouselWidth;

        $mobileShadePicker.animate({
          scrollLeft: scrollPosition
        });
      });

      $seeAllshade.once().on('click', function (e) {
        e.preventDefault();
        $prevCar.removeClass('hidden');
        $nextCar.removeClass('hidden');
        var $vtoFoundationFilter = $mobileShadePicker.find('.vto-filter');

        $vtoFoundationFilter.removeClass('first-filter vto-pipe-first last-filter vto-pipe-last');
        $(this).removeClass('active');
        $seeMyPerfect.addClass('active');
        $swatches.addClass('active');
        if ($swatchContainer) {
          $swatchContainer.addClass('active');
        }
        $mobileShadePicker.addClass('all-shades');
        $mobileShadePicker.removeClass('perfect-shades');
        var perfectMatchShades = $('.vto-filter').length * $firstSwatch;

        if (perfectMatchShades) {
          setShadeWidth(100 / perfectMatchShades + '%');
        }
        $mobileShadePicker.scrollTo($mobileShadePicker.find('a.selected'), {
          duration: 350,
          offset: -40
        });
      });

      $seeMyPerfect.once().on('click', function (e) {
        e.preventDefault();
        $prevCar.addClass('hidden');
        $nextCar.addClass('hidden');
        var $vtoFoundationFilter = $mobileShadePicker.find('.vto-filter');

        $vtoFoundationFilter = $vtoFoundationFilter.sort((a, b) => {
          return $(a).css('order') < $(b).css('order') ? -1 : 1;
        });

        $vtoFoundationFilter.first().addClass('first-filter vto-pipe-first');
        $vtoFoundationFilter.last().addClass('last-filter vto-pipe-last');
        $(this).removeClass('active');
        $seeAllshade.addClass('active');
        $swatches.removeClass('active');
        if ($swatchContainer) {
          $swatchContainer.removeClass('active');
        }
        $mobileShadePicker.removeClass('all-shades');
        $mobileShadePicker.addClass('perfect-shades');
        var perfectMatchShades = $('.vto-filter').length * $firstSwatch;

        if (perfectMatchShades) {
          setShadeWidth(100 / perfectMatchShades + '%');
        }
        changeSKU($mobileShadePicker.find('.vto-filter.js-best-match .js-swatch'));
      });

      function addChatIcon() {
        var $chatIcon = $('.lt-label-event');

        $chatIcon.removeClass('hidden');
      }

      function closeYoucamModule() {
        var $chatLiveIcon = $('.LPMcontainer');

        $chatLiveIcon.removeClass('hidden');
        var $chatLiveButton = $('.wo-chat-btn');

        $chatLiveButton.removeClass('hidden');
        var $chatLiveButtonLabel = $('.lt-label-icon-wrap');

        $chatLiveButtonLabel.removeClass('hidden');
        addChatIcon();
        $foundationVtoContainer.addClass('hidden');
        $foundationVtoButton.removeClass('hidden');
        $swatches.removeClass('vto-filter first-filter selected active js-best-match best-match vto-pipe-first vto-pipe-last js-foundation-vto-lighter foundation-vto-lighter js-foundation-vto-warmer foundation-vto-warmer js-foundation-vto-guid foundation-vto-guid js-foundation-vto-cooler foundation-vto-cooler js-foundation-vto-darker foundation-vto-darker last-filter');
        $swatchFilter.html('');
        if (isMob) {
          // enable scrolling
          $bodyElement.removeClass('no-scroll');
        }
        // reset youcam module
        window.YMK.closeEngine();
        $mobileShadePickContainer.removeClass('active');
        if (hasVtoDiscloseParam) {
          openYoucamModule();
        }
      }

      $foundationOverlayClose.once().on('click', function (e) {
        var $chatLiveIcon = $('.LPMcontainer');

        $chatLiveIcon.removeClass('hidden');
        var $chatLiveButton = $('.wo-chat-btn');
        var $chatLiveButtonLabel = $('.lt-label-icon-wrap');

        $chatLiveButtonLabel.removeClass('hidden');
        addChatIcon();
        e.preventDefault();
        $chatLiveButton.removeClass('hidden');
        closeYoucamModule();
      });

      $foundationVtoUndertoneClose.once().on('click', function (e) {
        e.preventDefault();
        $foundationVtoUndertoneContainer.addClass('hidden');
        $foundationVtoUndertoneContent.addClass('hidden');
        $foundationVtoUndertoneBackground.addClass('hidden');
      });

      $foundationVtoUndertonePopup.once().on('click', function (e) {
        e.preventDefault();
        $foundationVtoUndertoneContainer.removeClass('hidden');
        $foundationVtoUndertoneContent.removeClass('hidden');
        $foundationVtoUndertoneBackground.removeClass('hidden');
      });

      function toggleMobileShadePick(state) {
        if (state === 'on') {
          var $activeSwatch = $mobileShadePicker.find('a.selected');

          $mobileShadePickContainer.removeClass('hidden');
          // scroll to active swatch
          $mobileShadePicker.scrollTo($activeSwatch, {
            duration: 350,
            offset: -40
          });
        } else if (state === 'off') {
          $mobileShadePickContainer.addClass('hidden');
        }
      }

      function changeSKU(swatch) {
        if (!swatch.length) {
          return null;
        }
        var skuBaseId = swatch.data('sku-base-id');
        var currentProductId = $('.js-product-full', context).attr('data-product-id');

        shadeSelected = false;

        var productData = prodcat.data.getProduct(currentProductId);
        var skuData = _.find(productData.skus, function (sku) {
          return sku.SKU_BASE_ID === skuBaseId;
        });

        $shadeContainer = swatch.closest('.js-swatches');
        site.skuSelect(skuData);
        // Update sku base id on button.
        $addToBagButton.data('sku-base-id', skuData.SKU_BASE_ID);
      }

      $swatches.once().on('click', function () {
        var $this = $(this);
        var skuBaseId = $this.find('a').data('sku-base-id');

        $('.js-product-full', context).trigger('product.skuSelect', skuBaseId).trigger('product.updateRoute', skuBaseId);
      });

      $swatch.once().on('click', function () {
        changeSKU($(this));
      });

      $bodyElement.on('sku:select', function (e, skuData) {
        if (shadeSelected) {
          return;
        }
        // update shadename
        var $shadeNameContainer = $('.js-shadename', $mobileShadePickContainer);
        var $shadePriceContainer = $('.js-shadeprice', $mobileShadePickContainer);
        var $shadeUndertone = $('.js-shade-undertone', $mobileShadePickContainer);
        var $shadeSwatchContainer = $('.js-current-swatch', $mobileShadePickContainer);
        // update mobile carousel
        var $curMobSwatch;
        var isRetailer = $bodyElement.hasClass('is-retailer');

        if ($shadeContainer) {
          $shadeContainer.parent($mobileShadePicker).find('.marked').removeClass('marked');
          $curMobSwatch = $shadeContainer.find('a[data-sku-base-id="' + skuData.SKU_BASE_ID + '"]');
          $shadeContainer = null;
        } else {
          $curMobSwatch = $mobileShadePickContainer.find('a[data-sku-base-id="' + skuData.SKU_BASE_ID + '"]');
        }
        // Update sku base id on button.
        $addToBagButton.attr('data-sku-base-id', skuData.SKU_BASE_ID);
        $mobileShadePickContainer.find('a.js-swatch').removeClass('selected');
        $swatches.removeClass('selected');
        $curMobSwatch.addClass('selected').closest('.swatches--single').addClass('selected');
        $swatches.find('.swatch__container').removeClass('marked');
        $curMobSwatch.siblings('.swatch__container').addClass('marked');
        $shadeNameContainer.html(skuData.SHADENAME);
        $shadePriceContainer.html(skuData.formattedPrice);
        $shadeUndertone.html(skuData.UNDERTONE);
        $shadeSwatchContainer.css('background-color', skuData.HEX_VALUE_STRING);
        // change the shade
        if (YMK) {
          YMK.applyMakeupBySku(skuData.PRODUCT_CODE);
        }
        if (skuData.VTO_FOUNDATION_ONLINE) {
          $foundationVtoButton.removeClass('hidden');
        } else {
          $foundationVtoButton.addClass('hidden');
        }
        shadeSelected = true;
        if (skuData && !skuData.isShoppable || isRetailer) {
          $addToBagButton.css('visibility', 'hidden');
        } else {
          $addToBagButton.css('visibility', 'visible');
          $addToBagButton.show();
          $addToBagButton.removeClass('button--disabled');
        }
      });
      $(document).on('change', '.js-vto-disclaimer-checkbox', function(e) {
        var isDisclaimerChecked = $(e.target).is(':checked');
        $foundationVtoOverlayButton.toggleClass('disabled', !isDisclaimerChecked);
      });
      $foundationVtoButton.once().on('click', function (e) {
        e.preventDefault();
        if (self.isMobile()) {
          openYoucamModule();
        } else {
          $foundationVtoQrOverlay.removeClass('hidden');
        }
      });
      window.GlobalServiceBus?.on(window.ServiceBusTopics.events.VTO_FOUNDATION_QR_CODE_OVERLAY_CLOSED, function() {
        $foundationVtoQrOverlay.addClass('hidden');
      });
      $(document).bind('addToCart.success', function () {
        var addedText = $addToBagButton.data('added-text');
        var atbText = $addToBagButton.html();

        $addToBagButton.html(addedText);
        setTimeout(function () {
          $addToBagButton.html(atbText);
        }, 3000);
      });
    }
  };
})(jQuery);
